/**
 * Basic data provider template
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var Emitter   = require('cjs-emitter'),
    keys      = require('stb-keys'),

    metrics = require('../metrics'),
    listSize = metrics[screen.height] ? metrics[screen.height].listSize : metrics[720].listSize,


    pageIndex = -1;


/**
 * Data provider
 *
 * @param {Object} config init parameters
 * @constructor
 */
function DataProvider () {
    Emitter.call(this);
}

DataProvider.prototype = Object.create(Emitter.prototype);
DataProvider.prototype.constructor = DataProvider;


DataProvider.prototype.pageSize = listSize;


/**
 * Callback after success getting data
 *
 * @callback getCallback
 * @param {Object} error object contains error information
 * @param {array} data to return
 */


/**
 * Get next part of data.
 *
 * @param {number} direction to get data
 * @param {function} callback after getting data
 */
DataProvider.prototype.get = function ( direction, callback ) {
    var data = [],
        size = window.core.taskManager.runHistory.length,
        endIndex, index;

    if ( direction === keys.right ) {
        if ( pageIndex < size - this.pageSize ) {
            ++pageIndex;
        }
    } else if ( direction === keys.left && pageIndex > 0 ) {
        --pageIndex;
    } else if ( direction !== null ) {
        return;
    } else if ( size > 0 ) {
        pageIndex = 0;
    }

    if ( size <= this.pageSize ) {
        endIndex = 0;
    } else {
        size = size - pageIndex;
        endIndex = size - this.pageSize;
    }

    for ( index = size - 1; index >= endIndex; --index ) {
        data.push({
            config: window.core.taskManager.runHistory[index]
        });
    }

    if ( data.length > 0 ) {
        while ( data.length < this.pageSize ) {
            data.push({
                config: {name: ''},
                disable: true
            });
        }
        callback(false, data);
    } else {
        callback(false, [
            {
                config: {name: ''},
                disable: true
            },
            {
                config: {name: ''},
                disable: true
            },
            {
                config: {name: ''},
                disable: true
            },
            {
                config: {name: ''},
                disable: true
            },
            {
                config: {name: ''},
                disable: true
            },
            {
                config: {name: ''},
                disable: true
            }
        ]);
    }
};

module.exports = new DataProvider();
